import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

export interface DashboardTextPromptDialogData {
  title: string;
  label: string;
  initialValue?: string;
}

@Component({
  standalone: true,
  selector: 'app-dashboard-text-prompt-dialog',
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <h2 mat-dialog-title class="text-lg">{{ data.title }}</h2>
    <mat-dialog-content>
      <mat-form-field appearance="outline" class="w-full min-w-[280px]">
        <mat-label>{{ data.label }}</mat-label>
        <input matInput name="layoutName" [(ngModel)]="layoutName" />
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close type="button">Cancel</button>
      <button
        mat-flat-button
        color="primary"
        type="button"
        [disabled]="!layoutName.trim()"
        (click)="submit()"
      >
        Save
      </button>
    </mat-dialog-actions>
  `,
})
export class DashboardTextPromptDialogComponent {
  data = inject<DashboardTextPromptDialogData>(MAT_DIALOG_DATA);
  private dialogRef = inject(MatDialogRef<DashboardTextPromptDialogComponent>);

  layoutName = this.data.initialValue ?? '';

  submit(): void {
    const v = this.layoutName.trim();
    if (!v) return;
    this.dialogRef.close(v);
  }
}
